
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Sarcelles dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Sarcelles certifiée Google Partner, accompagne les entreprises sarcelloises pour booster leur visibilité et générer davantage de prospects.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Sarcelles dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Sarcelles certifiée Google Partner, accompagne les entreprises sarcelloises pour booster leur visibilité et générer davantage de prospects.",
        },
      ],
    };
  },
};
